import React from "react";

import * as styles from "./index.module.scss";

const Overlay = ({ overlayColour }) => {
    if (!overlayColour || typeof overlayColour === "undefined")
        return null;

    const style = {
        backgroundImage: `linear-gradient(0deg, ${overlayColour}, ${overlayColour})`
    };

    return <div className={ styles.overlay } style={style}></div>;
}

export default Overlay;